import { t } from 'i18next';
import { FilterBadge } from 'models/filter';
import { queryParams } from 'utils/query';

export const useBadges = (): FilterBadge[] => {
  const badges: FilterBadge[] = [
    {
      queryParameter: queryParams.status,
      label: t('badge_only_active'),
      renderValue: (value: string) => t(`label_patient_status_${value}`),
    },
    {
      queryParameter: queryParams.hasMeasurement,
      label: t('badge_only_measurement'),
      renderValue: (value: string) => t(`${value}_label`),
    },
    {
      queryParameter: queryParams.lastMeasurementResultType,
      label: t('badge_last_measurement_result'),
      renderValue: (value: string) => t(`indicator_label_${value}`),
    },
    {
      queryParameter: queryParams.lastMostSevereMeasurementResultType,
      label: t('badge_last_most_severe_measurement_result'),
      renderValue: (value: string) => t(`indicator_label_${value}`),
    },
  ];

  return badges;
};
